import { Layout, Skeleton } from 'antd';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { EcfmgHeaderContainer } from '../../shared/ecfmg-header/ecfmg-header.container';
import { AccessBlockedScreen } from '../../shared/access-blocked-screen/access-blocked-screen';
import { ImpendingMessage } from '../../shared/maintenance-message/impending-message';
import { useMaintenanceMessage } from '../../shared/maintenance-message';
import { MaintenanceMessage } from '../../shared/maintenance-message/maintenance-message';


const { Content } = Layout;
interface SectionLayoutProps {
  isAccessBlocked: boolean;
}
export const SectionLayout: React.FC<SectionLayoutProps> = (props) => {
  const location = useLocation();
  const { isImpending, isMaintenance } = useMaintenanceMessage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Layout
      style={{
        minHeight: '100vh',
        width: '100vw',
        overflowX: 'hidden',
        overflowY: 'hidden'
      }}
    >
      <EcfmgHeaderContainer />
      {isMaintenance === undefined ? (
        <Skeleton />
      ) : isMaintenance ? (
        <div style={{ transform: 'translateY(-0px)' }}>
          <MaintenanceMessage />
        </div>
      ) : isImpending === undefined ? (
        <Skeleton />
      ) : isImpending ? (
        <div>
          <div style={{ transform: 'translateY(60px)' }}>
            <ImpendingMessage />
          </div>
          <Layout
            style={{
              transform: 'translateY(60px)'
            }}
          >
            <Content
              style={{
                overflowX: 'hidden',
                width: '100%'
              }}
            >
              {props.isAccessBlocked && <AccessBlockedScreen />}
              {!props.isAccessBlocked && <Outlet />}
            </Content>
          </Layout>
        </div>
      ) : (
        <Layout
          style={{
            transform: 'translateY(60px)'
          }}
        >
          <Content
            style={{
              overflowX: 'hidden',
              width: '100%'
            }}
          >
            {props.isAccessBlocked && <AccessBlockedScreen />}
            {!props.isAccessBlocked && <Outlet />}
          </Content>
        </Layout>
      )}
    </Layout>
  );
};

